module.exports = __webpack_public_path__ + "static/media/promotionResumptionPackageUnder45.5ad65f49.webp";